module.exports = __webpack_public_path__ + "static/media/make_payment_button.9b9c30bb.svg";